import { render } from "./ChangelogPopup.vue?vue&type=template&id=774f2734&scoped=true"
import script from "./ChangelogPopup.vue?vue&type=script&lang=js"
export * from "./ChangelogPopup.vue?vue&type=script&lang=js"

import "./ChangelogPopup.vue?vue&type=style&index=0&id=774f2734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774f2734"]])

export default __exports__